//import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { MenuItem, MenuItemStateProps } from '@src/components';
import { Features } from '@src/core/features';
import { useTheme } from '@src/themes';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProjectContext } from '../switch-project';

const CalendarMenu: FC<MenuItemStateProps> = ({ isMini }) => {
  const { allowedFeature } = useProjectContext();
  const { COLORS } = useTheme();
  const navigate = useNavigate();

  if (!allowedFeature(Features.CALENDAR)) {
    return <></>;
  }

  const handleClick = () => {
    navigate('/calendar', { replace: true });
  };

  return (
    <MenuItem
      isMini={isMini}
      item={{
        title: 'Agenda',
        icon: <CalendarMonthIcon sx={{ color: COLORS.primary.main }} />,
        ignoreDefaultAvatarStyle: true,
      }}
      onClick={handleClick}
    />
  );
};

export { CalendarMenu };
